<div class="currentAgentStatesGraphView position-relative">
    <canvas baseChart *ngIf="chartConfig"
        class="currentAgentStatesCxoneGraph chartjs-render-monitor"
        width="443"
        height="412"
        style="display: block; width: 443px; height: 412px;"
        [type]="chartConfig.type"
        [legend]="chartConfig.options.plugins.legend.display"
        [datasets]="chartConfig.data.datasets"
        [labels]="chartConfig.data.labels"
        [options]="chartConfig.options">
    </canvas>
</div>
